export default {
  siteName: 'RPM Consulting, Inc.',
  siteUrl: 'https://rpmconsultinginc.com',
  contacts: {
    email: 'info@rpmconsultinginc.com',
    phoneNo: '303-595-7625',
    faxNo: '303-595-7628',
    address: '2110 Overland Ave, Ste 105, Billings, MT 59102',
  },
  nav: {
    indexSlug: 'index',
    indexTitle: 'Home',
    contactsSlug: 'contact',
  },
};



// WEBPACK FOOTER //
// ./src/config.js